import { zodResolver } from '@hookform/resolvers/zod'
import moment from 'moment'
import { QbsTable } from 'qbs-react-grid'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'

import { exportData, impersonate } from '../../apis/common.apis'
import { TableColumns } from '../../common/types'
import InfoBox from '../../components/app/alertBox/infoBox'
import { PrimaryFilterComponent } from '../../components/app/filterComponents/primaryFilter'
import { Button, DialogModal, TextField } from '../../components/common'
import { TagActions } from '../../components/common/emailChip'
import Icons from '../../components/common/icons'
import ListingHeader from '../../components/common/ListingTiles'
import { useSnackbarManager } from '../../components/common/snackbar'
import { checkPermissions } from '../../layout/store'
import { useAuthStore } from '../../store/authStore'
import { useSignatoryFilterstore } from '../../store/filterSore/signatoryFilterStore'
import { calcWindowHeight } from '../../utilities/calcHeight'
import { getErrorMessage, getSortedColumnName } from '../../utilities/parsers'
import { handleReturnEmptyMsg } from '../../utilities/validation'
import {
  changePasswordSchema,
  ChangePasswordSchema,
} from '../AdminUser/create/schema'
import {
  deactivateOrgUser,
  getOrgUserDetailsInAdminPortal,
  sendOrgUserInvitation,
  updateOrgUserPassword,
} from '../organisation/api'
import CreateOrganisationUser from '../organisation/details/user/create'
import { useSignatoryList } from './api'
import { getColumns } from './columns'

const fixedInputClass =
  'rounded appearance-none relative block w-full px-3 py-2 border border-formBorder placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-purple-500 focus:border-gray-300 focus:z-10 sm:text-sm'

export default function Signatories() {
  const [columns, setColumns] = useState<TableColumns[]>([])

  const { userData } = useAuthStore()

  const {
    pageParams,
    setPageParams,

    setAdvanceFilter,
  } = useSignatoryFilterstore()
  const { page, page_size, search, ordering, filters, filterProps } = pageParams
  const searchParams = {
    page: page,
    page_size: page_size,
    search: search,
    ordering: ordering,
    ...filters,
    is_email_sent: false,
    recipient_email: '',
  }
  const { enqueueSnackbar } = useSnackbarManager()

  const [openConfirm, setOpenConfirm] = useState(false)
  const [deactivateItem, setDeactivateItem] = useState('')

  const [userName, setUserName] = useState('')
  const [userId, setUserId] = useState('')
  const [status, setStatus] = useState('')
  const [deactivateModal, setDeactivateModal] = useState(false)
  const [changePassword, setChangePassword] = useState(false)
  const [showPassword, setShowPassword] = useState({
    new_password: false,
  })

  const [viewMode, setViewMode] = useState(false)
  const [edit, setEdit] = useState(false)
  const [rowData, setRowData] = useState<any>()
  const [createOpen, setCreateOpen] = useState(false)

  const [editViewIndicator, setEditViewIndicator] = useState(false)
  const [viewIndicator, setViewIndicator] = useState(false)

  const { data, isFetching, refetch } = useSignatoryList(searchParams)
  const onChangePage = (row: number) => {
    setPageParams({
      ...pageParams,
      page: row,
    })
  }
  const onChangeRowsPerPage = (count: number | string) => {
    setPageParams({
      ...pageParams,
      page_size: count,
      page: 1,
    })
  }
  const onViewAction = async (row: any) => {
    setViewIndicator(true)
    if (row?.user?.id) {
      const data = await getOrgUserDetailsInAdminPortal(
        row?.organisation?.id,
        row?.user?.id
      )
      setRowData(data)
    }
    setViewMode(true)
    setCreateOpen(true)
  }
  useEffect(() => {
    setColumns(
      getColumns({
        onViewAction: onViewAction,
      })
    )
  }, [])

  const handleSeach = (key?: string) => {
    setPageParams({
      ...pageParams,
      search: key as string,
      page: 1,
    })
  }

  const basicData = {
    title: 'All Organisation Users',
    icon: 'user',
  }

  const handleSort = (orderColumn: any, orderDirection: any) => {
    setPageParams({
      ...pageParams,
      sortColumn: orderColumn,
      sortType: orderDirection,
      ordering: getSortedColumnName(orderColumn, orderDirection),
    })
  }

  // const filterDetails = GetFilterDetails()
  const filterDetails: any[] = []
  const handleFilterChange = (dta: any, name: string, id: string) => {
    const currentParams = useSignatoryFilterstore.getState()?.pageParams || {}

    const getDefaultFilters = () => ({
      ...currentParams.filters,
      [id]: dta?.id ?? undefined,
    })

    const getDefaultFilterProps = () => ({
      ...currentParams.filterProps,
      [name]: dta[name] ?? undefined,
    })
    const filters = getDefaultFilters()
    const filterProps = getDefaultFilterProps()
    setPageParams({
      ...currentParams,
      page: 1,
      filters,
      filterProps,
    })
  }

  const handleImpersonate = async (row: any) => {
    try {
      if (row?.user?.id) {
        const res = await impersonate(row?.user?.id)
        if (res) {
          const name = `${row.user?.first_name} ${row.user?.last_name}`
          const url = `${res?.impersonation_url}?token=${encodeURIComponent(res.access_token)}&userId=${encodeURIComponent(row?.user?.id)}&name=${encodeURIComponent(name)}&impersonator_id=${encodeURIComponent(userData.id as string)}`
          window.open(url, '_blank')
        } else {
          enqueueSnackbar('Impersonation Failed', { variant: 'error' })
        }
      }
    } catch (err: any) {
      enqueueSnackbar('ERROR', { variant: 'error' })
    }
  }

  const handleOpenInvitation = (row: any) => {
    setRowData(row)
    setDeactivateItem(row?.user?.id)
    setOpenConfirm(true)
  }
  const handleSendInvitation = () => {
    sendOrgUserInvitation(rowData?.organisation?.id, deactivateItem)
      .then((res) => {
        enqueueSnackbar(
          res.message ? res.message : 'Invitation Send Successfully',
          {
            variant: 'success',
          }
        )
        setRowData('')
        refetch()
        setOpenConfirm(false)
      })
      .catch((err) => {
        enqueueSnackbar(
          err?.response?.data?.error?.message || err?.response?.data?.message,
          { variant: 'error' }
        )
      })
  }
  const handleDeactivateModel = (
    id: string,
    username: string,
    status: string
  ) => {
    setDeactivateItem(id)
    setDeactivateModal(true)
    setUserName(username)
    setStatus(status)
  }
  const handleDeactivateOrgUser = () => {
    deactivateOrgUser(rowData?.organisation?.id, deactivateItem)
      .then((res: any) => {
        enqueueSnackbar(
          res.message ? res.message : 'Status updated successfully',
          {
            variant: 'success',
          }
        )
        refetch()
        setDeactivateModal(false)
      })
      .catch((err: any) => {
        enqueueSnackbar(
          err?.response?.data?.error?.message || err?.response?.data?.message,
          { variant: 'error' }
        )
      })
  }
  const {
    formState: { errors },
    handleSubmit,
    register,
    reset,
  } = useForm<ChangePasswordSchema>({
    mode: 'onChange',
    resolver: zodResolver(changePasswordSchema),
    defaultValues: { new_password: '' },
  })
  const handleResetPassword = (userId: string, username: string) => {
    setChangePassword(true)
    setUserId(userId)
    setUserName(username)
  }
  const handleResetPasswordClose = () => {
    reset({ new_password: '' })
    setChangePassword(false)
  }
  const onSubmit = (datas: any, e: any) => {
    e?.preventDefault()
    updateOrgUserPassword(rowData?.organisation?.id, userId, datas)
      .then(() => {
        handleResetPasswordClose()
        enqueueSnackbar('Password changed successfully', {
          variant: 'success',
        })
        setRowData('')
      })
      .catch((error) => {
        enqueueSnackbar(getErrorMessage(error?.response.data.error), {
          variant: 'error',
        })
      })
  }
  const handleEdit = async (row: any) => {
    if (row?.user?.id) {
      const data = await getOrgUserDetailsInAdminPortal(
        row?.organisation?.id,
        row?.user?.id
      )
      setRowData(data)

      setCreateOpen(true)
      setViewMode(false)
      setEdit(true)
    }
  }
  const handleClose = () => {
    setCreateOpen(false)
    if (viewIndicator && editViewIndicator) {
      setViewIndicator(false)
      setEditViewIndicator(false)
      onViewAction(rowData)
    }
  }
  const handleRefresh = () => {
    refetch()
  }
  const onHandleExport = async () => {
    let input = {}
    if (emailIds.length > 0) {
      input = {
        ...searchParams,
        is_email_sent: true,
        recipient_email: emailIds,
      }
    } else {
      input = {
        ...searchParams,
        is_email_sent: false,
        recipient_email: '',
      }
    }
    try {
      const data = await exportData(input, 'SIGNATORIES_EXPORT', '')
      const currentDate = new Date()
      const formattedDate = moment(
        currentDate.toISOString().slice(0, 10)
      ).format('YYYY-MM-DD')
      if (emailIds.length === 0) {
        const url = window.URL.createObjectURL(data as any)
        const filename = `Signatories_${formattedDate}.xlsx`
        const a = document.createElement('a')
        a.href = url

        a.download = filename
        document.body.appendChild(a)
        a.click()

        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
      } else {
        if (data) {
          enqueueSnackbar(
            'Your report is being processed and will be emailed shortly',
            { variant: 'success' }
          )
        }
      }
    } catch (error) {
      enqueueSnackbar('Failed to send data', { variant: 'error' })
    }
  }
  const [exportPopup, setExportPopup] = useState(false)
  const [emailIds, setEmailIds] = useState<string[]>([])
  const [emailError, setEmailError] = useState('')

  const handleEmailUpdate = (emails: string[]) => {
    setEmailError('')
    setEmailIds(emails)
  }

  const handleExportSubmit = () => {
    if (emailIds.length === 0) {
      setEmailError('Required')
    } else {
      console.log('Emails to export:', emailIds)
      onHandleExport()
      setEmailIds([])
      setExportPopup(false)
    }
  }

  const handleExportCancel = () => {
    setEmailError('')
    setEmailIds([])
    setExportPopup(false)
  }
  const headerProps = {
    hideExport: data?.items?.length === 0,
  }

  return (
    <div>
      <DialogModal
        isOpen={exportPopup}
        onClose={() => handleExportCancel()}
        title={'Send Via Email'}
        onSubmit={() => handleExportSubmit()}
        secondaryAction={() => handleExportCancel()}
        secondaryActionLabel="Cancel"
        actionLabel={'Send'}
        // actionLoader={loader}
        className="z-50"
        submitDisabled={emailError !== '' || emailIds.length === 0}
        body={
          <>
            <InfoBox content="Enter the recipient’s email address in the field above and press ‘Enter’ to confirm. You can add multiple email addresses if needed. Once you’re done, click ‘Send’ to proceed or ‘Cancel’ to go back." />
            <p className="my-2 labels label-text">{'Email ID'}</p>
            <div className="flex flex-col label-badges">
              <TagActions
                onUpdate={handleEmailUpdate}
                error={emailError}
                setError={setEmailError}
              />
            </div>
          </>
        }
      />
      <ListingHeader
        data={basicData}
        onHandleExport={onHandleExport}
        setExportPopup={setExportPopup}
        actionProps={headerProps}
      />
      <div className=" p-4">
        <QbsTable
          data={data?.items ?? []}
          dataRowKey="id"
          toolbar={true}
          search={true}
          height={
            data?.length === 0 ? calcWindowHeight(218) : calcWindowHeight(335)
          }
          isLoading={isFetching}
          sortType={pageParams.sortType}
          sortColumn={pageParams.sortColumn}
          handleColumnSort={handleSort}
          emptyTitle="No records to display"
          emptySubTitle={handleReturnEmptyMsg(search)}
          columns={columns}
          pagination={true}
          renderSortIcon={(sortType?: 'asc' | 'desc' | undefined) => {
            return sortType === 'asc' ? (
              <Icons name="ascending-icon" />
            ) : sortType === 'desc' ? (
              <Icons name="descending-icon" />
            ) : (
              <Icons name="qbs-sort-icon" />
            )
          }}
          paginationProps={{
            onPagination: onChangePage,
            total: data?.total,
            currentPage: pageParams?.page,
            rowsPerPage: Number(pageParams?.page_size ?? data?.page_size),
            onRowsPerPage: onChangeRowsPerPage,
            dropOptions: [10, 20, 30, 50, 100],
          }}
          searchValue={pageParams?.search}
          onSearch={handleSeach}
          asyncSearch
          handleSearchValue={(key?: string) => handleSeach(key)}
          columnToggle
          primaryFilter={
            false && (
              <PrimaryFilterComponent
                filterParams={filterDetails}
                handleFilterChange={handleFilterChange}
                filterProps={filterProps}
                isPrimary={true}
                setAdvanceFilter={setAdvanceFilter}
              />
            )
          }
          actionProps={[
            {
              icon: <Icons name="edit" />,
              action: (row: any) => handleEdit(row),
              title: 'edit',
              toolTip: 'Edit',
              hidden: !checkPermissions('UserList', 'edit'),
            },
            {
              icon: <Icons name="verify" />,
              action: (row: any) => {
                setRowData(row)
                handleResetPassword(row?.user?.id, row?.user?.username)
              },
              title: 'reset-password',
              toolTip: 'Reset Password',
              hidden: !checkPermissions('UserList', 'reset-password'),
            },
            {
              title: 'Deactivate',
              action: (rowData) => {
                setRowData(rowData)
                handleDeactivateModel(
                  rowData?.user?.id,
                  rowData?.user?.username,
                  rowData?.user?.status
                )
              },
              icon: <Icons name="deactivate-icon" />,
              toolTip: 'Deactivate',
              hide: (rowData: any) =>
                rowData?.user?.status == 'Active' ? false : true,
              hidden: !checkPermissions('UserList', 'de-activate'),
            },
            {
              title: 'Activate',
              action: (rowData) => {
                setRowData(rowData)
                handleDeactivateModel(
                  rowData?.user?.id,
                  rowData?.user?.username,
                  rowData?.user?.status
                )
              },
              icon: <Icons name="activate-icon" />,
              toolTip: 'Activate',
              hide: (rowData: any) =>
                rowData?.user?.status == 'Inactive' ? false : true,
              hidden: !checkPermissions('UserList', 'activate'),
            },
            {
              title: 'Send Invitation',
              action: (rowData) => handleOpenInvitation(rowData),
              icon: <Icons name="email" />,
              toolTip: 'Send Invitation',
              hidden: !checkPermissions('UserList', 'send-invitaion'),
            },
            {
              title: 'Impersonate',
              action: (rowData) => handleImpersonate(rowData),
              icon: <Icons name="user" />,
              hide: (row) =>
                userData?.id === row?.user?.id ||
                row?.user?.status === 'Inactive',
              toolTip: 'Impersonate',
              hidden: !checkPermissions('UserList', 'impersonate'),
            },
          ]}
        />
        <DialogModal
          isOpen={openConfirm}
          onClose={() => setOpenConfirm(false)}
          title={'Send Invitation'}
          onSubmit={() => handleSendInvitation()}
          secondaryAction={() => setOpenConfirm(false)}
          secondaryActionLabel="Cancel"
          actionLabel="Send"
          body={
            <InfoBox
              content={'Are you sure you want to send the invitation?'}
            />
          }
        />
        <DialogModal
          isOpen={deactivateModal}
          onClose={() => setDeactivateModal(false)}
          // title={'Deactivate User'}
          title={status == 'Active' ? 'Deactivate User' : 'Activate User'}
          onSubmit={() => handleDeactivateOrgUser()}
          secondaryAction={() => setDeactivateModal(false)}
          secondaryActionLabel="Cancel"
          actionLabel={status == 'Active' ? 'Deactivate' : 'Activate'}
          className="z-50"
          body={
            <>
              {status == 'Active'
                ? 'Are you sure to deactivate this user ?'
                : 'Are you sure to activate this user ?'}
              <div className="flex flex-col gap-4">
                <div className="w-full flex flex-col gap-2">
                  <TextField
                    id="1"
                    name="email"
                    value={userName ?? ''}
                    disabled={true}
                  />
                </div>
              </div>
            </>
          }
        />
        <DialogModal
          isOpen={changePassword}
          onClose={() => handleResetPasswordClose()}
          title={'Reset Password'}
          className="z-50"
          body={
            <form onSubmit={(e) => handleSubmit(onSubmit)(e)} noValidate>
              <div className="flex flex-col pt-2 ">
                <label className="labels label-text" htmlFor={'new_password'}>
                  Password
                </label>
                <div className="relative">
                  <input
                    id={'new_password'}
                    type={showPassword.new_password ? 'text' : 'password'}
                    required={true}
                    placeholder={'Enter Password'}
                    className={fixedInputClass}
                    {...register('new_password')}
                  />
                  <button
                    type="button"
                    className="absolute right-2 top-2.5 z-10"
                    onClick={() =>
                      setShowPassword({
                        ...showPassword,
                        new_password: !showPassword.new_password,
                      })
                    }
                  >
                    {showPassword.new_password ? (
                      <Icons name="eye" />
                    ) : (
                      <Icons name="eye-close" />
                    )}
                  </button>
                </div>
                {errors.new_password && (
                  <div className="text-xs text-red-500">
                    {errors?.new_password?.message as string}
                  </div>
                )}
              </div>
              <div className="flex flex-col py-5">
                <div className=" flex flex-row items-end gap-2 w-full justify-end ">
                  <Button
                    label="Cancel"
                    outlined={true}
                    primary={false}
                    onClick={() => handleResetPasswordClose()}
                  />

                  <Button label="Submit" type="submit" className="bg-primary" />
                </div>
              </div>
            </form>
          }
        />
        {createOpen && (
          <CreateOrganisationUser
            isDrawerOpen={createOpen}
            rowData={rowData}
            edit={edit}
            setViewMode={setViewMode}
            setEdit={setEdit}
            viewMode={viewMode}
            paramsId={rowData?.organisation?.id}
            handleClose={handleClose}
            handleRefresh={handleRefresh}
            domainType={'Employee'}
            editViewIndicator={editViewIndicator}
            setEditViewIndicator={setEditViewIndicator}
          />
        )}
      </div>
    </div>
  )
}
